/* eslint-disable */
// import lottie from 'lottie';
import lottie from 'lottie-web';

export function hasCSSClass(elem, className) {
  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
}
export function loop() {
  // const animations = ['animIntro','enquete-man'];
  // const animations = ['animIntro','digitaleezHomepage'];
  // const animations = ['Homepage_wex'];
  const animations = hasCSSClass(document.body, 'digitaleez') ? ['digitaleezHomepage'] : hasCSSClass(document.body, 'wexit') ? ['wexitHomepage'] : hasCSSClass(document.body, 'prestation-article') ? [] : ['Homepage1920_wex'];
  let path = themeurl.themeurl+'/assets/scripts/animation';
  if(hasCSSClass(document.body, 'digitaleez')) path += '/digitaleez';
  if(hasCSSClass(document.body, 'wexit')) path += '/wexit';
  let i,
    len = animations.length;
  for (i = 0; i < len; i += 1) {
    if (document.getElementById(animations[i]) !== null) {
      let anim;
      let elem = document.getElementById(animations[i]);
      let animData = {
        container: elem,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        rendererSettings: {
          progressiveLoad: true,
          preserveAspectRatio: 'xMidYMid meet',
          viewBoxOnly: true
        },
        path: path + '/' + animations[i] + '.json'
      };
      anim = lottie.loadAnimation(animData);
      anim.setSubframe(false);
    }
  }
}

export function start(animation, durationAnimation) {
  let start = false;
  init(animation);
  $(window).scroll(function () {
    if (!start) { // si l'animation n'a encore jamais été lancé
      let animInterfaceTop = $('#' + animation).offset().top;
      let monScroll = $(window).scrollTop() + $(window).height() / 2;
      if (monScroll > animInterfaceTop) { // si je suis au milieu de son container target
        play(animation, durationAnimation);
        start = true;
      }
    }
  });
}

function init(animation) {
  let path = themeurl.themeurl+'/assets/scripts/animation';
  if(hasCSSClass(document.body, 'digitaleez')) path += '/digitaleez';
  if(hasCSSClass(document.body, 'wexit')) path += '/wexit';
  if (document.getElementById(animation) !== null) {
    let anim;
    let elem = document.getElementById(animation);
    let animData_start = {
      container: elem,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      name: animation,
      rendererSettings: {
        className: 'start-anim hide',
        progressiveLoad: true,
        preserveAspectRatio: 'xMidYMid meet',
        viewBoxOnly: true
      },
      path: path + '/' + animation + '_start' + '.json'
    };
    let animData_loop = {
      container: elem,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      name: animation,
      rendererSettings: {
        className: 'loop-anim hide',
        progressiveLoad: true,
        preserveAspectRatio: 'xMidYMid meet',
        viewBoxOnly: true
      },
      path: path + '/' + animation + '_loop' + '.json'
    };
    if(animation == 'animContact') {
      let dataImg = $(elem).data('image');
      let dataImgURL = dataImg.substr(0, dataImg.lastIndexOf('/'))+'/';
      let dataImgFile = dataImg.substr(dataImg.lastIndexOf('/')+1);
      $.getJSON(animData_start.path, function(data){
        data.assets[0].u = dataImgURL;
        data.assets[0].p = dataImgFile;
        animData_start.animationData = data;
        delete animData_start.path;
        lottie.loadAnimation(animData_start);
      });
      $.getJSON(animData_loop.path, function(data){
        data.assets[0].u = dataImgURL;
        data.assets[0].p = dataImgFile;
        animData_loop.animationData = data;
        delete animData_loop.path;
        lottie.loadAnimation(animData_loop);
      });
    } else {
      lottie.loadAnimation(animData_start);
      lottie.loadAnimation(animData_loop);
    }
  }
}

function play(animation, durationAnimation) {
  let path = themeurl.themeurl+'/assets/scripts/animation';
  if(hasCSSClass(document.body, 'digitaleez')) path += '/digitaleez';
  if(hasCSSClass(document.body, 'wexit')) path += '/wexit';

  if (document.getElementById(animation) !== null) {
    let anim;
    let startAnim = $('#' + animation + ' .start-anim');
    let loopAnim = $('#' + animation + ' .loop-anim');
    // Animation de start
    startAnim.removeClass('hide');
    lottie.play(animation);
    // Animation de loop
    setTimeout(() => {
      startAnim.remove();
      loopAnim.removeClass('hide');
    }, durationAnimation);
    // document.getElementById(animation).addEventListener('complete', () => {
      // elem.childNodes[0].remove();
    // });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/bodymovin.js